import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../../http-main.service';
import { ListModel} from '@itb-monorepo/models';
import { Observable } from 'rxjs';
import {GradesResponseModel} from "@itb-monorepo/models";

@Injectable()
export class GradesService {
  private _HttpMainService = inject(HttpMainService);
  baseUrl = '/trade/';


  getGrades(): Observable<ListModel<GradesResponseModel>> {
    const url = `${this.baseUrl}v1/grades`;
    const requestParams: any = {
      sort: `asc(min_client)`
    };
    return this._HttpMainService.get(url, requestParams);
  }
}
